import styled from 'styled-components';
import { theme } from '../../theme';

export const LogoHolder = styled.div`
  position: absolute;
  top: 3rem;
  left: 3rem;
  bottom: 7rem;
  right: ${({ $isMobile }) => $isMobile ? '3rem' : 'unset'};
  display: flex;
  flex-direction: ${({ $isMobile }) => $isMobile ? 'row' : 'column'};
  justify-content: center;
  align-items: center;
`

export const StyledMintComponent = styled.div `
  width: 100%;
  padding: 0px 20px;
  background: ${({theme}) => theme.background};
  left: 0;
  right: ${({ theme }) => theme.frameOffset};
  top: ${({ theme }) => theme.navHeight};  
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 0;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  background: ${({theme}) => theme.mintDarkblue};

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 12px;
    padding-top: 12px;
  }
`
  
export const Delimiter = styled.div`
  width: 100%;
  height: 10px;
  background: white;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    height: 4px;
  }
`

export const Trailer = styled.video`
  width: 100%;
`

export const TrailerControls = styled.div`
  position: absolute;
  bottom: 3rem;
  right: 3rem;
`

export const TrailerContainer = styled.div`
  position: relative;
  width: 100%;
`
